// Material UI
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";

export const generateInfluencerForm = (
  email,
  setEmail,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  vanityUrl,
  setVanityUrl,
  brandId,
  setBrandId,
) => {
  const formLabels = [
    {
      Label: "First Name",
      Element: "TextField",
      Value: firstName,
      Setter: setFirstName,
    },
    {
      Label: "Last Name",
      Element: "TextField",
      Value: lastName,
      Setter: setLastName,
    },
    {
      Label: "Email",
      Element: "TextField",
      Value: email,
      Setter: setEmail,
    },
    {
      Label: "Vanity Url",
      Element: "TextField",
      Value: vanityUrl,
      Setter: setVanityUrl,
    },
    {
      Label: "Brand",
      Element: "FormControl",
      Value: brandId,
      Setter: setBrandId,
      Data: <>
      <option value="" />
        {[{brand: "SF", _id: 2}, {brand: "PDC", _id: 3}, {brand: "SPR", _id: 5}, {brand: "PRR", _id: 6}, {brand: "PF", _id: 8}].map((card, idx) => {
          let brandId = "";
          switch (card.brand) {
            case "KLS":
              brandId = card._id;
              break;
            case "SF":
              brandId = card._id;
              break;
            case "PDC":
              brandId = card._id;
              break;
            case "PIS":
              brandId = card._id;
              break;
            case "SPR":
              brandId = card._id;
              break;
            case "PRR":
              brandId = card._id;
              break;
            case "QPR":
              brandId = card._id;
              break;
            case "PF":
              brandId = card._id;
              break;
            default:
              return null;
          }
          return (
            <option key={idx} value={brandId}>
              {card.brand}
            </option>
          );
        })}
    </>
    },
  ];

  return formLabels.map(
    ({ Label, Element, Type, Data, Value, Setter }, idx) => {
      switch (Element) {
        case "TextField":
          return (
            <TextField
              id="outlined-full-width"
              className="input-el"
              label={Label}
              type={Type}
              style={{ margin: 8, width: "14rem" }}
              fullWidth={false}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            />
          );
        case "FormControl":
          return (
            <FormControl
              variant="outlined"
              style={{ margin: 8, width: "14rem" }}
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            >
              <InputLabel htmlFor="outlined-age-native-simple">
                {Label}
              </InputLabel>
              <Select
                native={true}
                label={Label}
                inputProps={{
                  name: `${Label.toLowerCase()}`,
                  id: `outlined-${Label.toLowerCase()}-native-simple`,
                }}
              >
                {Data}
              </Select>
            </FormControl>
          );
        default:
          return null;
      }
    }
  );
};

